module.exports = __webpack_public_path__ + "img/1.bc986e8b.png";